<template>

  <div>
    <div style="padding:6px 16px 0px 16px;">
        <div class="apply-title">
          <div>撤销申请</div>
        </div>
        <el-form v-loading="loading" ref="formRef" :model="formValue">
          <el-form-item label="撤销原因" prop="comments">
            <el-input type="textarea" v-model="formValue.comments" placeholder="请输入" maxlength="255" rows="4"  show-word-limit />
          </el-form-item>
        </el-form>
    </div>
    <div style="display: flex;justify-content: end">
      <el-button size="small" type="warning" plain @click="$emit('close')">取 消</el-button>
      <el-button size="small" type="warning" :loading="loading" @click="handleConfirm">撤 销</el-button>
    </div>
  </div>
</template>

<script>
import { revoke } from "@/api/oa/audit.js";

export default {
  name: 'RevokeModal',
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false
    },
    processInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      formValue: {
        comments: ''
      },
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  methods: {
    // 取消操作
    handleCancel() {
      this.$emit('cancel');
      this.$refs.formRef.resetFields();
      this.formValue = {
        comments: "",
        imageList: [],
        fileList: [],
      };
      this.show = false;
    },
    // 确认操作
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if(!valid) return;
        const params = {
          ...this.processInfo,
          ...this.formValue,
        }
        this.loading = true
        revoke(params).then(() => {
          this.$message.success('操作成功');
          this.handleCancel();
          // 成功事件交给父组件统一处理（关闭弹层、返回上一页等）
          this.$emit('success');
          this.$emit('close')
        }).finally(() => {
          this.loading = false
        })
      })
    },
  }
}
</script>
<style scoped>
.apply-title{
  font-weight: bold;
  font-size: 15px;
  text-align: center;
}
</style>